import type {BreadcrumbMap} from './route-breadcrumb'

export const breadcrumbMap: BreadcrumbMap = {
  '/tutorials/digifort': 'Tutoriais - Digifort',
  '/tutorials/dguard': 'Tutoriais - D-guard',
  '/tutorials/moni': 'Tutoriais - Moni',
  '/forbidden': 'Acesso Negado',
  '/dashboard': 'Dashboard',
  '/events': 'Eventos',
  '/license-plate': 'LPR',
  '/notifications': 'Notificações',
  '/facial-recognition': 'Reconhecimento Facial',
  '/camera-mosaic': 'Mosaico',
  '/upload-dataset': 'Upload de Dataset',
  '/registers/devices': 'Cadastros - Dispositivos',
  '/registers/analytic-cameras': 'Cadastros - Câmeras Analíticas',
  '/registers/brainbox': 'Cadastros - Brain Box',
  '/registers/clients': 'Cadastros - Clientes',
  '/registers/lists': 'Cadastros - Listas',
  '/registers/users': 'Cadastros - Usuários',
  '/registers/edge-servers': 'Cadastros - Servidores de Borda',
  '/settings/inputs': 'Configurações - Integrações de Entrada',
  '/settings/outputs': 'Configurações - Integrações de Saída',
  '/settings/credentials': 'Configurações - Credenciais',
  '/settings/company-data': 'Configurações - Dados da Empresa',
  '/administrative/quotas': 'Administrativo - Cotas',
  '/administrative/companies': 'Administrativo - Empresas',
  '/terms': 'Termos',
}
